/* eslint-disable no-unused-vars */

export enum POINT_GAME_TYPE {
  NONE = 0, // 'none', // 게임 종류는 아니지만 사용자 원장구분을 위해 선언
  SCRATCH = 1, // 'scratch', // 스크래처
  ROULETTE = 2, // 'roulette', // 룰렛
  LOTTERY = 3, // 'lottery', // 로또
}

export enum POINT_BET_STATUS {
  ADMIN, // 관리지가 지급
  ING, // 게임 진행 중 (항상 마이너스)
  SMALL_WIN, // 소액 당첨
  WIN, // 게임에서 당첨 포인트
  JACKPOT, // 잭팟 당첨액
  SWAP_TO_POINT, // 토큰(sfl)을 포인트로 교환, token -> point
  SWAP_TO_TOKEN, // 포인트를 토큰으로 교환, point -> token
  REFERRAL_BET, // 레퍼럴 베팅
  REFERRAL_WIN, // 레퍼럴 당첨
  REFERRAL_SMALL_WIN, // 레퍼럴 소액 당첨
}

export enum POINT_BET_SWAP_TYPE {
  TOKEN_TO_POINT = 0, // 포인트 충전 sfl -> point // 바로 진행
  POINT_TO_TOKEN = 1, // 토큰 출금 point -> sfl // 관리자 승인 후 진행
}

export enum POINT_BET_SWAP_STATUS {
  WAITING = 0, // 대기
  COMPLETED = 1, // 완료
  FAILED = 2, // 실패
  ING = 3, // 진행 중
  ADMIN_PROGRESS = 4, // 관리자 진행 중
  REFUSED = 5, // 거절
}
